import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    class: String // The targeted class to scroll to
  }

  toTarget(event) {
    event.preventDefault()
    const target = this.element.ownerDocument.querySelector(this.classValue)
    if (target) {
      target.scrollIntoView({ behavior: "smooth" })
    }
  }
}
